import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum UnableToAutoOnboardReason {
  ERROR_GETTING_DELIVERY_PROFILES_FROM_SHOPIFY = "ERROR_GETTING_DELIVERY_PROFILES_FROM_SHOPIFY",
  NO_SHIPPING_PROFILES_IN_SHOPIFY = "NO_SHIPPING_PROFILES_IN_SHOPIFY",
  AUTO_ONBOARDING_WORKFLOW_RUNNING = "AUTO_ONBOARDING_WORKFLOW_RUNNING",
}

export const canAutoOnboardCheckoutOptimization = {
  name: "canAutoOnboardCheckoutOptimization" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.union([
    z.object({ canAutoOnboard: z.literal(true) }),
    z.object({
      canAutoOnboard: z.literal(false),
      reason: createEnum(UnableToAutoOnboardReason),
    }),
  ]),
};
